import { FunctionComponent, useState } from "react";
import InfoIcon from "../assets/icons/info.svg";
import styles from "./InfoBox.module.css";

interface Props {
  defaultOpen?: boolean;
}

export const InfoBox: FunctionComponent<Props> = ({
  defaultOpen,
  children,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={styles.container}>
      {open ? (
        <div className={styles.content}>
          {children}
          <button className={styles.button} onClick={() => setOpen(false)}>
            ✕
          </button>
        </div>
      ) : (
        <button
          className={styles.button}
          onClick={() => setOpen(true)}
          title="Info"
        >
          <img className={styles.icon} src={InfoIcon.src} alt="Info" />
        </button>
      )}
    </div>
  );
};
